import React from 'react';
import './Login.css';

export default function Error() {
  return (
    <>
    <div className='flexer'>
        <div className='Background'>
            <p id="green">C</p><p id="white">O</p><p id="white">D</p><p id="white">E</p>
            <div></div>
            <p id="green">P</p><p id="white">E</p><p id="white">N</p><p id="white">...</p>
        </div>
        <div className='error'>
            <p id="green">404</p><p id='white'>Page  Not  Found :(</p>
        </div>
    </div>

    </>
  )
}
